import { render, staticRenderFns } from "./UpdateMoneyFilter.vue?vue&type=template&id=467a3dd8&"
import script from "./UpdateMoneyFilter.vue?vue&type=script&lang=js&"
export * from "./UpdateMoneyFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports